export * from './FileTypeTextIcon';
export * from './FileTypeTextIcon16Light';
export * from './FileTypeTextIcon16Regular';
export * from './FileTypeTextIcon16Solid';
export * from './FileTypeTextIcon20Light';
export * from './FileTypeTextIcon20Regular';
export * from './FileTypeTextIcon20Solid';
export * from './FileTypeTextIcon24Regular';
export * from './FileTypeTextIcon24Solid';
export * from './FileTypeTextIcon32Regular';
export * from './FileTypeTextIcon64Regular';
